import { h } from 'vue';

import ViewLeaf from '../ViewLeaf.vue';

export default ({
  t,
  accountScopedRoute,
  contactCustomViews,
  labels,
  currentUserId,
  isAdmin,
  onDeleteContactView,
  onToggleContactViewShared,
}) => ({
  name: 'Contacts',
  label: t('SIDEBAR.CONTACTS'),
  icon: 'i-ph-address-book',
  children: [
    {
      name: 'All Contacts',
      label: t('SIDEBAR.ALL_CONTACTS'),
      to: accountScopedRoute(
        'contacts_dashboard_index',
        {},
        { page: 1, search: undefined }
      ),
      activeOn: ['contacts_dashboard_index', 'contacts_edit'],
    },
    {
      name: 'Active',
      label: t('SIDEBAR.ACTIVE'),
      to: accountScopedRoute('contacts_dashboard_active'),
      activeOn: ['contacts_dashboard_active'],
    },
    {
      name: 'Segments',
      icon: 'i-ph-users-four',
      label: t('SIDEBAR.CUSTOM_VIEWS_SEGMENTS'),
      collapsible: true,
      showTreeLine: true,
      // Saved contact views (CustomFilter records with
      // `filter_type: contact`). The leaf body swaps in the shared ViewLeaf
      // for the ⋯ manage menu; owners manage their own views, admins
      // additionally manage (and share/unshare) shared ones.
      children: contactCustomViews.map(view => ({
        name: `${view.name}-${view.id}`,
        label: view.name,
        to: accountScopedRoute(
          'contacts_dashboard_segments_index',
          { segmentId: view.id },
          { page: 1 }
        ),
        activeOn: [
          'contacts_dashboard_segments_index',
          'contacts_edit_segment',
        ],
        component: leafProps =>
          h(ViewLeaf, {
            ...leafProps,
            shared: Boolean(view.shared),
            canManage:
              view.user_id === currentUserId ||
              (Boolean(view.shared) && Boolean(isAdmin)),
            canShare: Boolean(isAdmin),
            onDelete: () => onDeleteContactView(view),
            onToggleShared: () => onToggleContactViewShared(view),
          }),
      })),
    },
    {
      name: 'Tagged With',
      icon: 'i-ph-tag',
      label: t('SIDEBAR.TAGGED_WITH'),
      collapsible: true,
      showTreeLine: true,
      // Unsorted on purpose: this reads the raw label list, not `sortedLabels`.
      children: labels.map(label => ({
        name: `${label.title}-${label.id}`,
        label: label.title,
        icon: h('span', {
          class: `size-[8px] rounded-sm`,
          style: { backgroundColor: label.color },
        }),
        to: accountScopedRoute(
          'contacts_dashboard_labels_index',
          { label: label.title },
          { page: 1, search: undefined }
        ),
        activeOn: ['contacts_dashboard_labels_index', 'contacts_edit_label'],
      })),
    },
  ],
});
